import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useRef } from 'react';
import DynamicAction from '../../../utils/DynamicAction';
import { DynamicActionKey } from '../../../utils/DynamicAction/DynamicAction';
import { sendMissionsEvent } from '../analytics/missionsLogger';
import { MISSIONS_STATES, MISSIONS_ACTIONS, MISSIONS_EVENT_TYPES } from '../constants';
import { hasGameIds } from '../utils/missionsPerformance';
import PushNotification from '../../../lib/notifications/PushNotification';
import Utils from '../../../utils';
import { usePostMissionsMutation } from '../../../state/query/missions';
import useFeatureFlags from '../../../hooks/useFeatureFlags';
import { FE_ANIMATION } from '../../../utils/featureFlags/constants';
import { getText, TEXT_KEY } from '../../../utils/localization';

var useMissionsActions = function useMissionsActions(_ref, description) {
  var _mainActionHandlers;

  var object = _ref.object,
      navigation = _ref.navigation,
      playerId = _ref.playerId;
  var _object$item = object.item,
      missionId = _object$item.missionId,
      counter = _object$item.counter,
      endTimestamp = _object$item.endTimestamp;

  var _useState = useState(description),
      _useState2 = _slicedToArray(_useState, 2),
      cardBottomText = _useState2[0],
      setCardBottomText = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      cardBottomStyle = _useState4[0],
      setCardBottomStyle = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showCollectCoinsAnimation = _useState6[0],
      setShowCollectCoinsAnimation = _useState6[1];

  var missionsRunningReward = useRef(false);
  var isWeb = Utils.getPlatform() === 'web';
  var collectCoinsAnimationMiddleProgress = isWeb ? 16 : 0.5;

  var isAnimationMiddleProgress = function isAnimationMiddleProgress(progress) {
    return Number(progress.toFixed(isWeb ? 0 : 2)) === collectCoinsAnimationMiddleProgress;
  };

  var _useFeatureFlags = useFeatureFlags(),
      hasFeature = _useFeatureFlags.hasFeature;

  var activeAnimations = hasFeature(FE_ANIMATION);

  var _usePostMissionsMutat = usePostMissionsMutation(),
      _usePostMissionsMutat2 = _slicedToArray(_usePostMissionsMutat, 2),
      postMissions = _usePostMissionsMutat2[0],
      isLoading = _usePostMissionsMutat2[1].isLoading;

  useEffect(function () {
    setCardBottomText(description);
  }, [description]);

  var runGameIfAvailable = function runGameIfAvailable() {
    var _counter$params, _counter$params2;

    return hasGameIds((_counter$params = counter.params) === null || _counter$params === void 0 ? void 0 : _counter$params.gameIds) && DynamicAction.getActionCallback("".concat(DynamicActionKey.LAUNCH_GAME, ":").concat((_counter$params2 = counter.params) === null || _counter$params2 === void 0 ? void 0 : _counter$params2.gameIds[0]), navigation)();
  };

  var handleMissionReady = function handleMissionReady() {
    postMissions({
      action: MISSIONS_ACTIONS.START_MISSION,
      missionId: missionId,
      playerId: playerId
    });
    !isWeb && PushNotification.scheduleMissionReminderNotification(endTimestamp, 1);
    runGameIfAvailable();
  };

  var handleCollectCoinsAnimationRunning = function handleCollectCoinsAnimationRunning(animationProgress) {
    var hasCurrentTime = animationProgress.hasOwnProperty('currentTime');
    var progress = hasCurrentTime ? animationProgress.currentTime : animationProgress;

    if (isAnimationMiddleProgress(progress) && !missionsRunningReward.current) {
      missionsRunningReward.current = true;
      handleMissionFinished();
    }
  };

  var handleMissionFinished = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return postMissions({
                action: MISSIONS_ACTIONS.CLAIM_MISSION_REWARD,
                missionId: missionId,
                playerId: playerId
              }).unwrap();

            case 2:
              sendMissionsEvent(MISSIONS_EVENT_TYPES.MISSIONS_CARD_REWARD_CLAIM);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleMissionFinished() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleMissionReward = function handleMissionReward() {
    activeAnimations ? setShowCollectCoinsAnimation(true) : handleMissionFinished();
  };

  var handleMissionLocked = function handleMissionLocked() {
    setCardBottomText(getText(TEXT_KEY.LOCKED_DESCRIPTION));
    setCardBottomStyle(true);
    setTimeout(function () {
      setCardBottomText(description);
      setCardBottomStyle(false);
    }, 2000);
  };

  var handleMissionRunning = function handleMissionRunning() {
    runGameIfAvailable();
  };

  var mainActionHandlers = (_mainActionHandlers = {}, _defineProperty(_mainActionHandlers, MISSIONS_STATES.LOCKED, handleMissionLocked), _defineProperty(_mainActionHandlers, MISSIONS_STATES.READY, handleMissionReady), _defineProperty(_mainActionHandlers, MISSIONS_STATES.RUNNING, handleMissionRunning), _defineProperty(_mainActionHandlers, MISSIONS_STATES.REWARD, handleMissionReward), _mainActionHandlers);
  return {
    cardBottomText: cardBottomText,
    cardBottomStyle: cardBottomStyle,
    mainActionHandlers: mainActionHandlers,
    isLoading: isLoading,
    showCollectCoinsAnimation: showCollectCoinsAnimation,
    handleCollectCoinsAnimationRunning: handleCollectCoinsAnimationRunning
  };
};

export default useMissionsActions;